import { matchPath } from "react-router-dom";

// #491: every route used to share index.html's one <title>, so tabs, history and
// bookmarks were indistinguishable. One map, checked against App.tsx by a test,
// so a new route cannot ship without a title.
const WEEK = "/teams/:teamId/series/:seriesSlug/weeks/:trackWeekId";

export const HOME_TITLE = "StintSense — Kill the runsheet";

export const ROUTE_TITLES: ReadonlyArray<readonly [pattern: string, title: string]> = [
  ["/privacy", "Privacy"],
  ["/terms", "Terms"],
  ["/login", "Sign in"],
  ["/signup", "Create an account"],
  ["/forgot-password", "Forgot password"],
  ["/reset-password", "Reset password"],
  ["/stream-overlay", "Stream overlay"],
  ["/insim-overlay", "In-sim overlay"],
  ["/join/:token", "Join a team"],
  ["/admin", "Admin"],
  ["/onboarding/team/new", "New team"],
  ["/teams", "Teams"],
  ["/teams/:teamId", "Team"],
  ["/teams/:teamId/settings", "Team settings"],
  ["/teams/:teamId/checklists", "Checklists"],
  ["/teams/:teamId/model-health", "Projection accuracy"],
  ["/teams/:teamId/setups", "Setup library"],
  ["/teams/:teamId/setups/compare", "Compare setups"],
  ["/teams/:teamId/pit-log", "Pit log"],
  ["/teams/:teamId/series/:seriesSlug", "Series"],
  [WEEK, "Week"],
  [`${WEEK}/overview`, "Overview"],
  [`${WEEK}/drivers`, "Drivers"],
  [`${WEEK}/qualifying`, "Qualifying"],
  [`${WEEK}/master`, "Master"],
  [`${WEEK}/head-to-head`, "Head-to-Head"],
  [`${WEEK}/fuel`, "Fuel"],
  [`${WEEK}/stints`, "Stints"],
  [`${WEEK}/handling`, "Handling"],
  [`${WEEK}/pit`, "Pit"],
  [`${WEEK}/checklist`, "Checklist"],
  [`${WEEK}/trends`, "Trends"],
  ["/runs/:id", "Run"],
  ["/teams/:teamId/live", "Live"],
  ["/teams/:teamId/live/:userId", "Driver"],
  ["/desktop", "Desktop agent"],
  ["/settings", "Settings"],
];

export function titleFor(pathname: string): string {
  if (pathname === "/") return HOME_TITLE;
  for (const [pattern, title] of ROUTE_TITLES) {
    if (matchPath({ path: pattern, end: true }, pathname)) return `${title} · StintSense`;
  }
  return "Page not found · StintSense";
}
